import moment from 'moment';

/**
 * ACTION USER EDIT INIT
 * Reset edit user
 */
export const userEditInit = () => {
  return (dispatch) => {
    dispatch({ type: 'USER_EDIT_INIT' });
  };
};

/**
 * ACTION USER EDIT
 * Edit user data
 * @param {object} data - user data
 */
export const userEdit = (data) => {
  return async (dispatch, getState, { getFirebase }) => {
    const profileCompany = getState().firebase.profile.company;
    if (data !== undefined && data.id !== undefined) {
      dispatch({ type: 'USER_EDIT_PENDING' });
      const firebase = getFirebase();
      const firestore = getFirebase().firestore();

      const userEditRole = async (role, id) => {
        const userRef = await firestore.collection('users').doc(id);
        return await firestore
          .collection('companies')
          .doc(profileCompany.id)
          .update(
            role === 'admins'
              ? {
                  admins: firebase.firestore.FieldValue.arrayUnion(userRef),
                  users: firebase.firestore.FieldValue.arrayRemove(userRef),
                  updatedAt: moment().utc().format('YYYY-MM-DDTHH:mm:ssZ'),
                }
              : role === 'users'
              ? {
                  admins: firebase.firestore.FieldValue.arrayRemove(userRef),
                  users: firebase.firestore.FieldValue.arrayUnion(userRef),
                  updatedAt: moment().utc().format('YYYY-MM-DDTHH:mm:ssZ'),
                }
              : {}
          )
          .then(() => {
            return true;
          })
          .catch((err) => {
            return err;
          });
      };

      const userEditPhoto = async (id, photo) => {
        const photoStorage = firebase.storage().ref(`users/${id}/photo.jpg`);
        return await photoStorage
          .put(photo)
          .then(async (snapshot) => {
            await snapshot.ref
              .getDownloadURL()
              .then(async (url) => {
                return await firestore
                  .collection('users')
                  .doc(id)
                  .update({
                    avatar: url,
                    updatedAt: moment().utc().format('YYYY-MM-DDTHH:mm:ssZ'),
                  })
                  .then(() => dispatch({ type: 'USER_PHOTO_UPDATE_SUCCESS' }))
                  .catch((err) => {
                    throw err;
                  });
              })
              .catch((err) => {
                return err;
              });
          })
          .catch((err) => {
            return err;
          });
      };

      return await firestore
        .collection('users')
        .doc(data.id)
        .update({
          updatedAt: moment().utc().format('YYYY-MM-DDTHH:mm:ssZ'),
        })
        .then(async () => {
          if (profileCompany && data.role)
            await userEditRole(data.role, data.id);
          if (data.photoData) await userEditPhoto(data.id, data.photoData);

          dispatch({ type: 'USER_EDIT_SUCCESS' });
          return true;
        })
        .catch(async (err) => {
          if (err.code === 'not-found') {
            return await firestore
              .collection('users')
              .doc(data.id)
              .set({
                createdAt: moment().utc().format('YYYY-MM-DDTHH:mm:ssZ'),
                updatedAt: moment().utc().format('YYYY-MM-DDTHH:mm:ssZ'),
              })
              .then(async () => {
                if (profileCompany && data.role)
                  await userEditRole(data.role, data.id);
                if (data.photoData)
                  await userEditPhoto(data.id, data.photoData);

                dispatch({ type: 'USER_EDIT_SUCCESS' });
                return true;
              })
              .catch((err) => {
                dispatch({ type: 'USER_EDIT_ERROR', err });
                return false;
              });
          }
          dispatch({ type: 'USER_EDIT_ERROR', err });
          return false;
        });
    } else return false;
  };
};

/**
 * ACTION USERS INVITE INIT
 * Reset invite users
 */
export const usersInviteInit = () => {
  return (dispatch) => {
    dispatch({ type: 'USERS_INVITE_INIT' });
  };
};

/**
 * ACTION USERS INVITE
 * Invite users data
 * @param {object} data - user data
 */
export const usersInvite = (data) => {
  return async (dispatch, getState, { getFirebase }) => {
    if (data !== undefined && data.users !== undefined) {
      dispatch({ type: 'USERS_INVITE_PENDING' });
      const firebase = getFirebase();
      const inviteUsers = firebase.functions().httpsCallable('inviteUsers');
      return await inviteUsers({ users: { ...data.users } })
        .then((res) => {
          if (res && res.data && res.data.status === 'success')
            dispatch({ type: 'USERS_INVITE_SUCCESS' });
          else throw res.data;
        })
        .catch((err) => dispatch({ type: 'USERS_INVITE_ERROR', err }));
    } else return false;
  };
};

/**
 * ACTION USER DELETE INIT
 * Reset delete user
 */
export const userDeleteInit = () => {
  return (dispatch) => {
    dispatch({ type: 'USER_DELETE_INIT' });
  };
};

/**
 * ACTION USER DELETE
 * Delete user data
 * @param {object} data - user data
 */
export const userDelete = (data) => {
  return async (dispatch, getState, { getFirebase }) => {
    if (data !== undefined && data.id !== undefined) {
      dispatch({ type: 'USER_DELETE_PENDING' });
      const firebase = getFirebase();
      const deleteUser = firebase.functions().httpsCallable('deleteUser');

      return await deleteUser({ uid: data.id })
        .then((res) => {
          if (res && res.data && res.data.status === 'success')
            dispatch({ type: 'USER_DELETE_SUCCESS' });
          else throw res.data;
        })
        .catch((err) => dispatch({ type: 'USER_DELETE_ERROR', err }));
    } else return false;
  };
};
